import commonHelper from '@/app/utility/common.helper.utility';
import addEditItemDetail from './addEditItemDetail';
import DatePicker from 'vue2-datepicker';
import appStrings from '@/app/utility/string.utility';
import commonItemModal from './commonItemModal';
import HistoryRecord from '@/app/components/onlineApproval/internalWorkFlow/history/historyRecord';
import ApprovalHistory from '@/app/components/onlineApproval/internalWorkFlow/history/approvalHistory';
import UploadDocument from '@/app/components/onlineApproval/internalWorkFlow/history/uploadDocument';
import sendForApproval from '@/app/components/onlineApproval/internalWorkFlow/history/sendForApproval';
import openKmAuthentication from '@/app/components/onlineApproval/internalWorkFlow/openKmAuthentication';
export default {
  name: 'purchaseRequisition',
  watch: {
    currentPage: function () {
      this.getItemData();
    },
    perPage: function () {
      this.currentPage = 1;
      this.getItemData();
    }
  },
  components: {
    addEditItemDetail,
    DatePicker,
    commonItemModal,
    HistoryRecord,
    ApprovalHistory,
    UploadDocument,
    sendForApproval,
    openKmAuthentication,
  },
  data() {
    return {
      loader: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      natureItem: {
        text: null,
        value: null
      },
      itemData: [],
      itemFields: [
        {
          key: 'select',
          variant: 'info',
          stickyColumn: true
        },
        {
          key: 'approval_status',
          class: 'text-center'
        },
        {
          key: 'oracle_status',
          class: 'text-center'
        },
        {
          key: 'asset_cat_name',
          label: 'Asset Category',
          class: 'text-center'
        },
        {
          key: 'expense_account_meaning',
          label: 'Expense Account',
          class: 'text-center'
        },
        {
          key: 'hsn_code',
          label: 'HSN Code',
          class: 'text-center'
        },
        {
          key: 'sac_code',
          label: 'SAC Code',
          class: 'text-center'
        },
        {
          key: 'item_code',
          class: 'text-center'
        },
        {
          key: 'item_type_meaning',
          label: 'Item Type',
          class: 'text-center'
        },
        {
          key: 'description',
          class: 'text-center'
        },
        {
          key: 'long_description',
          label: 'Long Description',
          class: 'text-center'
        },
        {
          key: 'nature_of_item_meaning',
          label: 'Nature of Item',
          class: 'text-center'
        },
        {
          key: 'status',
          class: 'text-center'
        },
        {
          key: 'tax_rate',
          class: 'text-center'
        },
        {
          key: 'tax_recoverable',
          class: 'text-center'
        },
        {
          key: 'template_meaning',
          class: 'text-center'
        },
        {
          key: 'uom_meaning',
          label: 'UOM',
          class: 'text-center'
        }
      ],
      showItemDetailModal: false,
      unsubscribe: null,
      showValueSetModal: false,
      rowData: null,
      vsetName: null,
      modalType: null,
      showCommonModal: false,
      showHistoryBtn: false,
      selectedItemDetail: {},
      showHistory: false,
      historyType: null,
      showOpenKmModal: false,
      openkmAuthToken: null,
      showApproveRejectModal: false,
      approvalReason: null,
      rejectedReason: null,
      approvalRemarks: null,
      rejectionRemarks: null,
      showExcelUploadModal: false,
      itemCode: null,
      itemDesc: null,
      itemHdrId: null
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          this.rowData = null;
          this.itemHdrId = null;
          this.showHideItemDetailModal(true);
        }
        // else if (actionName === 'upload') {
        //   this.showHideExcelUpload(true);
        // }
      }
    });
  },
  methods: {
    showHideItemDetailModal(flag) {
      this.showItemDetailModal = flag;
      if (!flag) {
        this.getItemData();
      }
    },
    mapSelectedVsetData(item) {
      if (this.modalType === 'legal_entity') {
        this.legalEntity = {
          text: item.le_name,
          value: item.le_id
        };
      } else if (this.modalType === 'period') {
        this.period = item.period_name;
      }
      this.showHideCommonModal(false);
    },
    // showHideCommonModal(flag, type) {
    //     this.modalType = type;
    //     this.showCommonModal = flag;
    //     if (flag) {
    //       if (this.modalType === 'period') {
    //         this.legalEntityValue = this.legalEntity.value;
    //       }
    //     } if (this.modalType === 'period' && !this.legalEntity.text) {
    //       this.showCommonModal = false;
    //       alert('Please Select Legal Entity.')
    //     } else {
    //       this.showCommonModal = flag;
    //     }
    //   }, 
    selectedItem(item) {
      this.selectedItemDetail = Object.assign({}, item);
      this.itemHdrId = item.item_id;
      this.showHistoryBtn = true;
    },
    rowSelected(item) {
      this.rowData = item;
      this.itemHdrId = item.item_id;
      this.selectedItemDetail = Object.assign({}, item);
      this.showHideItemDetailModal(true);
    },
    updateItemData(item){
      this.itemHdrId = item;
      this.getItemData();
    },
    showHideHistory(flag, historyType) {
      this.showHistory = flag;
      this.historyType = historyType;
      if (!flag) {
        this.getItemData();
      }
    },
    // async isDocumentUploadedFunc() {
    //   const uploadedDocList = await commonHelper.getUploadedDocList(
    //     this.$store.state.shared.menuId,
    //     this.selectedItemDetail.prov_hdr_id
    //   );
    // const isDocumentUploaded = uploadedDocList.length > 0;
    // isDocumentUploaded
    //   ? this.showHideHistory(true, 'sendForApproval')
    //   : alert('Please upload document!');
    // },
    validateUploadDocument() {
      // if (this.selectedItemDetail.approval_status === 'DRAFT') {
      //   this.isDocumentUploadedFunc();
      // } else {
      this.showHideHistory(true, 'sendForApproval');
      // }
    },
    checkOpenKmPasswordSaved() {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/checkSavedPassword')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if (response.data.data) {
              this.getOpenKmAuthToken();
            } else {
              this.showHideOpenKmModal(true);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthToken() {
      const payload = {
        password: null,
        saved_password_flag: true,
        user_name: null
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmAuthenticate', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openkmAuthToken = response.data.data.token;
            // this.selectedGridData = {
            //   ...this.selectedItemDetail,
            //   nfa_cat_vset: null,
            //   nfa_cat: null,
            //   nfa_sub_cat_vset: null,
            //   nfa_sub_cat: null
            // };
            this.showHideHistory(true, 'uploadDocument');
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideOpenKmModal(flag) {
      this.showOpenKmModal = flag;
    },
    setOpenKmToken(token) {
      this.showHideOpenKmModal(false);
      this.openkmAuthToken = token;
      // this.selectedGridData = {
      //   ...this.selectedItemDetail,
      //   nfa_cat_vset: null,
      //   nfa_cat: null,
      //   nfa_sub_cat_vset: null,
      //   nfa_sub_cat: null
      // };
      this.showHideHistory(true, 'uploadDocument');
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.parent_value_set_id = null;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (
        this.vsetCode === appStrings.VALUESETTYPE.NATURE_OF_ITEM
      ) {
        this.natureItem = {
          text: item.value_meaning,
          value: item.value_code
        };
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === appStrings.VALUESETTYPE.NATURE_OF_ITEM) {
        this.natureItem = {
          text: null,
          value: null
        };
      }
    },
    getItemData() {
      // this.$v.$touch();
      // if (!this.$v.$invalid) {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        user_id: this.$store.state.auth.userId,
        description: this.itemDesc,
        item_code: this.itemCode,
        nature_of_item: this.natureItem.value,
      };
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getItemData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.itemData = result;
            this.totalRows = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
      // }
    },
    clear() {
      this.natureItem = {
        text: null,
        value: null
      };
      this.itemCode = null;
      this.itemDesc = null;
      this.showHistoryBtn = false;
      this.totalRows = null;
      this.itemData = [];
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
